import React from 'react';

/** Boostrap Components */  
import { Card,Container,Row,Col,Form,Button } from 'react-bootstrap';  

/** Select component */
import Select from 'react-select'

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';
import SideMenuComponent from './sidemenu';

import { AUTH_URL,UPLOAD_URL,UPLOAD_FULL_URL, DEMANDS_FOR_GRANTS_URL, FINYEAR_LIST_URL } from '../utils/constants';

class UploadDFGComponent extends React.Component { 
	constructor(props) {
		super(props);
		this.state = {
			pdfFile: '',
			finYear: '',
			id: '',
			items: [],
			finyearList: [],
			disableSelect: false,
			uploadFullPdf: '',
			isLoaded: false
		}
		this.onChangeFinyear = this.onChangeFinyear.bind(this);
		this.onChangeId = this.onChangeId.bind(this);
		this.handleSelectOption = this.handleSelectOption.bind(this);
	}

	componentDidMount() {
		fetch(AUTH_URL,{method:'POST',headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}})
			.then(res => res.json())
			.then(user => {
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json',Authorization: 'Bearer' },
					body: JSON.stringify({ fin_year: '-',options: 'all' })
				};
		
				fetch(DEMANDS_FOR_GRANTS_URL,requestOptions)
					.then(res => res.json())
					.then(
						(result) => {
							this.setState({
								isLoaded: true,
								items: result.DATA
							});
						},
						(error) => {
							this.setState({
								isLoaded: true,
								error
							});
						}
					)
		
				fetch(FINYEAR_LIST_URL,{method : 'POST'})
					.then(res => res.json())
					.then(
						(result2) => {
							this.setState({
								isLoaded: true,
								finyearList: result2
							});
						},
						(error) => {
							this.setState({
								isLoaded: true,
								error
							});
						}
					)
					})
			.catch(error => {
				// alert('Unauthorized Login!!');
				// this.props.history("/login");
				// return false;
			})

	}

	onChangeFinyear = event => {
		this.setState({finYear: event.value});
	}
	onChangeId = event => {
		this.setState({id: event.value});
	}
	handleSelectOption = event => {
		var value = (event.target.checked)?true:false;
		this.setState({disableSelect: value,uploadFullPdf: value});
	}
	onFileChange = event => {
		this.setState({ pdfFile: event.target.files[0] });
	};
	  
	onFileUpload = (event) => {
		event.preventDefault();
		const formData = new FormData();
		formData.append("id",this.state.id);
		formData.append("fin_year",this.state.finYear);
		formData.append("username",sessionStorage.getItem('user'));

		formData.append(
		  "pdfFile",
		  this.state.pdfFile,
		  this.state.pdfFile.name
		);

		var url = UPLOAD_URL;
	   	if(this.state.uploadFullPdf === true)
			url = UPLOAD_FULL_URL;

		fetch(url,{method:'POST',body:formData})
			.then(res => res.json())
			.then(
				(result) => {
					alert(result.MESSAGE);
					event.target.reset();
					//this.setState({disableSelect: false,uploadFullPdf: false});
				},
				(error) => {
					alert("Error while uploading")
				}
			)

	};

	render() {

		const { items, finyearList,disableSelect } = this.state;

		var options = []
		items.forEach(item=>{
			var app_no = (item.appropriation_no == null)?'':item.appropriation_no+' - ';
			if(item.demand_no !== '0')
				options.push({value: item.id, label: item.demand_no+' - '+app_no +item.description});
		})
	
		var finyearOptions = [];
		finyearList.forEach(finyear=>{
			finyearOptions.push({value: finyear, label: finyear})
		})
		return (
			<div>
				<NavbarComponent/>
				<nav className="sticky"></nav>
				<div className="App-common main"> 
					<Container>
						<Row className='mt-3'>
							<Col sm="4" md="3" lg="3">
								<SideMenuComponent/>
							</Col>
							<Col sm="8" md="9" lg="9">
								<Card border="">
									<Card.Body>
										<Row className='centered-form'>
											<div style={{fontWeight: "bold",fontSize: "large",marginBottom:"10px",borderBottom:"2px solid #3998ac"}}>
												Upload Demands for Grants
											</div>
											<Col className="nomobile"></Col>
											<Col xs="12" sm="12" md="5" lg="5">
												<Form onSubmit={this.onFileUpload}>
													<Form.Group className="mb-3">
														<Form.Label>Select Financial Year</Form.Label>
														<Select options={finyearOptions} name="finYear" id="finYear" onChange={this.onChangeFinyear}/>
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Check type="switch" name="uploadFullPdf" id="uploadFullPdf" label="Upload Full Demands for Grants" onChange={this.handleSelectOption}/>
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>Select demand no/appropriation no</Form.Label>
														<Select options={options} name="id" id="id" onChange={this.onChangeId} isDisabled={disableSelect}/>
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>Select file to upload</Form.Label>
														<Form.Control type="file" size="sm" name="pdfFile" id="pdfFile" onChange={this.onFileChange}/>
													</Form.Group>
													<Form.Group className="mb-3 text-end">
														<Button type="submit">Save</Button>
													</Form.Group>									
												</Form>
												</Col>
											<Col className="nomobile col-3"></Col>
										</Row>
									</Card.Body>
								</Card>						
							</Col>
						</Row>
					</Container>
				</div>
				<FooterComponent/>
			</div>
		)
		}
} 
 
export default UploadDFGComponent